import React from 'react'
import { useImmerReducer } from 'use-immer'
import reducer, { initialState } from './reducers/index'
import Context from './context'
import { GestureProvider } from './components/GestureProvider'

const Provider = ({ children }: { children: React.ReactNode }) => {
  const [state, dispatch] = useImmerReducer(reducer, initialState)

  // these variables will be available via the context
  const value = {
    state,
    dispatch,
  }

  return (
    <Context.Provider value={value}>
      <GestureProvider>{children}</GestureProvider>
    </Context.Provider>
  )
}

export default Provider
